import { AccessReviewListItem } from 'components/pages/accessreview/my-tasks/list/task-overview-list'
import { EndUserDashboardSection } from 'components/pages/end-user-dashboard/EndUserDashboardSection'
import { CertifyTaskType } from 'components/pages/task/type'
import { UserContext } from 'lib/context/app'
import { routes } from 'lib/routes'
import { AccessReviewSearchServiceRollupRequest } from 'pbts/c1/api/accessreview/v1/accessreview_search'
import { TaskSearchCountRequest, TaskSearchCurrentStep, TaskSearchRequest } from 'pbts/c1/api/task/v1/search'
import { FC, useContext } from 'react'
import { useIntl } from 'react-intl'
import { accessReviewRollupApi, AccessReviewRollupValue } from 'redux_toolkit/access_review/access_review_rollup'
import { getTaskSearchCountApi } from 'redux_toolkit/tasks'

export const EndUserDashboardMyReviews: FC = () => {
    const intl = useIntl()
    const { user } = useContext(UserContext)
    const userId = user?.id

    const filter = TaskSearchRequest.create({
        assigneesInIds: [userId],
        taskTypes: [CertifyTaskType],
        currentStep: TaskSearchCurrentStep.APPROVAL,
    })

    return <EndUserDashboardSection<AccessReviewRollupValue, AccessReviewSearchServiceRollupRequest, TaskSearchCountRequest>
        title={intl.formatMessage({
            id: 'end_user_dashboard_my_reviews_title',
            defaultMessage: 'To review',
        })}
        seeAllHref={routes.assignments.reviews.list}
        seeAllLabel={(count): string => intl.formatMessage({
            id: 'end_user_dashboard_my_reviews_see_all',
            defaultMessage: 'See all {count} reviews',
        }, { count })}
        ListItemComponent={AccessReviewListItem}
        getDataHook={accessReviewRollupApi.useRollup}
        getDataRequest={AccessReviewSearchServiceRollupRequest.create({ userId, excludeCompleted: true })}
        getCountHook={getTaskSearchCountApi.useSearchCount}
        getCountRequest={TaskSearchCountRequest.create({ filter })}
        invalidateHook={accessReviewRollupApi.useInvalidateRollup}
        isHorizontal
    />
}
